import { useEffect } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { mediaUrl } from "@/lib/api";

export const Lightbox = ({ photos, index, onClose, onIndex }) => {
  const photo = photos[index];
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onIndex((index + 1) % photos.length);
      if (e.key === "ArrowLeft") onIndex((index - 1 + photos.length) % photos.length);
    };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [index, photos.length, onClose, onIndex]);

  if (!photo) return null;
  const navBtn = "absolute top-1/2 -translate-y-1/2 grid h-12 w-12 place-items-center rounded-full bg-black/60 text-white transition-colors hover:bg-[#FFD23F] hover:text-[#121214]";
  return (
    <div className="fixed inset-0 z-[70] flex flex-col bg-black/95" role="dialog" aria-modal="true" data-testid="lightbox" onClick={onClose}>
      <div className="flex justify-end p-3">
        <button className="grid h-12 w-12 place-items-center rounded-full bg-white/10 text-white hover:bg-white/20" onClick={onClose} data-testid="lightbox-close-button" aria-label="Close">
          <X className="h-6 w-6" />
        </button>
      </div>
      <div className="relative flex min-h-0 flex-1 items-center justify-center px-2 sm:px-16" onClick={(e) => e.stopPropagation()}>
        <img src={mediaUrl(photo.url)} alt={photo.caption || "Project photo"} className="max-h-full max-w-full object-contain" data-testid="lightbox-image" />
        {photos.length > 1 && (
          <>
            <button className={`${navBtn} left-2`} onClick={() => onIndex((index - 1 + photos.length) % photos.length)} data-testid="lightbox-prev-button" aria-label="Previous photo">
              <ChevronLeft className="h-6 w-6" />
            </button>
            <button className={`${navBtn} right-2`} onClick={() => onIndex((index + 1) % photos.length)} data-testid="lightbox-next-button" aria-label="Next photo">
              <ChevronRight className="h-6 w-6" />
            </button>
          </>
        )}
      </div>
      <div className="px-4 pb-6 pt-3 text-center" onClick={(e) => e.stopPropagation()}>
        {photo.caption && <p className="text-base text-zinc-100" data-testid="lightbox-caption">{photo.caption}</p>}
        <p className="mt-1 text-xs text-zinc-500">{index + 1} / {photos.length}</p>
      </div>
    </div>
  );
};
